// GuiaAprendizajePage.jsx
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import AdaptacionesCurriculares from "../../components/Form/Fields/AdaptacionesCurriculares";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import TemaClase from "../../components/Form/Fields/TemaClase";
import GuiaAprendizajeCardImg from "../../components/UmmIApps/Cards/GuiaAprendizajeCardImg.png";
import GetObjetivosAprendizaje from "../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";

const GuiaAprendizajePage = () => {

  const {
    nivelId,
    materiaId,
    promptData,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    handleBack,
    setTextoInicial,
    handleInitialPromptData,
    isOAAdded,
    handleNivelChange,
    handleAsignaturaChangeLocal,
  } = useActividadesContext();

  const isButtonDisabled = !(
    promptData.nivel &&
    promptData.materia &&
    promptData.tema &&
    isOAAdded
  );
  const colorIconBack = "#BA4534";

  useEffect(() => {
    const init = {
      objetivos: [],
      materia: "",
      nivel: "",
      caracterizacion: "",
      condiciones_contexto: "",
      tema: "",
      adaptaciones_curriculares: "",
      temperatura: 0.1,
      idioma:"español"
    };
    handleInitialPromptData(init, "guia_aprendizaje");
    setTextoInicial(
      "A continuación te propongo 12 posibles preguntas y actividades para incluir en una guía de aprendizaje. Selecciona las que mejor se ajusten a tus preferencias y contexto y proponlas a tus estudiantes. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <UmmiaAppsLayout
      onBack={handleBack}
      imageSrc={GuiaAprendizajeCardImg}
      backgroundColorImage={
        "linear-gradient(180deg, #FFFFFF 0%, #E3B5AE 100%, #C86A5D 100%)"
      }
      title="Guía de aprendizaje l"
      description="Genera guías de trabajo con preguntas de elaboración y reflexión del contenido"
      titleColor="#BA4534"
      isButtonDisabled={isButtonDisabled}
      colorIconBack={colorIconBack}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} lg={12} display="flex" flexDirection="row">
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mr: 2, mb: 4 }}>
            <GetNiveles
              onNivelChange={handleNivelChange}
              selectedNivel={nivelId}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mb: 4 }}>
            <GetAsignaturas
              nivelId={nivelId}
              onAsignaturaChange={handleAsignaturaChangeLocal}
              selectedAsignatura={materiaId}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <GetObjetivosAprendizaje
            nombreAsignatura={promptData.materia}
            nombreNivel={promptData.nivel}
          />
        </Grid>
        <Grid item xs={12} lg={12} display="flex" flexDirection="row">
          <TemaClase />
        </Grid>

        <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandMoreIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>
        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <>
            <Grid item xs={12} lg={12} display="flex" flexDirection="row">
              <CondicionesContexto />
            </Grid>

            <Grid item xs={12} lg={12} display="flex" flexDirection="row">
              <Caracterizacion />
            </Grid>

            <Grid item xs={12} lg={12} display="flex" flexDirection="row">
              <AdaptacionesCurriculares />
            </Grid>
          </>
        )}
      </Grid>
    </UmmiaAppsLayout>
  );
};

export default GuiaAprendizajePage;
